import { useEffect, type RefObject } from 'react';

const COLLAPSED_CLASS = 'header-container--collapsed';
const SCROLL_THRESHOLD = 48;

export function useCollapsibleHeader(
  ref: RefObject<HTMLElement | null>,
  enabled = true
) {
  useEffect(() => {
    if (!enabled) return;

    const el = ref.current;
    if (!el) return;

    const mq = window.matchMedia('(max-width: 767px)');

    const update = () => {
      if (!mq.matches) {
        el.classList.remove(COLLAPSED_CLASS);
        return;
      }
      el.classList.toggle(COLLAPSED_CLASS, window.scrollY > SCROLL_THRESHOLD);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    mq.addEventListener('change', update);

    return () => {
      window.removeEventListener('scroll', update);
      mq.removeEventListener('change', update);
      el.classList.remove(COLLAPSED_CLASS);
    };
  }, [ref, enabled]);
}
